import { Component, h } from '@stencil/core';

@Component({
  tag: 'uui-logo',
  shadow: true,
  styleUrl: 'uui-logo.css'
})
export class UuiLogo {
  render() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 906.99 343.69">
          <path
            fill="#eb0017"
            d="M890.73,117.56c0,2.64-.05,5.28-.05,7.91V294H826.91V6c.77,0,1.54-.1,2.3-.1,17,0,34.08,0,51.12,0A4.13,4.13,0,0,1,884,7.6q67.24,83.48,134.57,166.91c.44.55.92,1.06,1.82,2.08V6.06h63.77v288.1H1082c-15.28,0-30.56,0-45.84,0a3.83,3.83,0,0,1-3.41-1.6Q982,229.65,931.24,166.75q-19.95-24.72-40-49.4l-.49-.45Z"
            transform="translate(-177.14 42.3)"
          />
          <path
            fill="#eb0017"
            d="M643.3,301.39c-34.74-1-70.82-15.39-100.1-45.11-29.53-30-44.33-66.38-43.73-108.56.59-40.87,15.76-75.93,44.58-104.76C570,17,601.5,2.24,638.14-.48c47.29-3.5,88,11.69,121.1,45.65,28.46,29.17,42.53,64.71,42.46,105.36C801.57,233.24,734.81,301,643.3,301.39ZM737.6,157c0-31.09-8.57-51.55-25.28-68.43s-37.54-25.51-61.4-25.69-44.7,8.36-61.58,25.26c-19.78,19.79-28.49,44-25.47,71.86a83.08,83.08,0,0,0,24.34,50.85c19.51,19.57,43.17,28.62,70.82,26.1C700.51,233.17,738.27,197.34,737.6,157Z"
            transform="translate(-177.14 42.3)"
          />
          <path
            fill="#eb0017"
            d="M523.14,294.16h-2.61q-32.4,0-64.8,0a2.83,2.83,0,0,1-3.14-2q-25.5-61.44-51.12-122.82C397.1,158.9,392.6,148.48,388.2,138q-6.1-14.49-12.12-29-12.51-30.28-25-60.58c-.27-.64-.64-1.24-1.16-2.24C331.71,90,313.66,133.32,295.45,177h2.91q34,0,67.92,0a3,3,0,0,1,3.31,2.17q11.91,27.42,24,54.79c.31.71.57,1.44,1,2.53h-3.05q-59,0-118.08-.07c-2.3,0-3.14.84-3.92,2.72-7.31,17.69-14.7,35.34-22,53-.53,1.28-1,2.06-2.64,2.06q-33.36-.1-66.72,0c-.24,0-.48,0-1-.09a20.37,20.37,0,0,1,.67-2q34.24-78.9,68.5-157.79,37.77-87,75.47-174.08c.81-1.88,1.72-2.56,3.82-2.54q24.48.15,49,0c2.14,0,3,.73,3.81,2.58q34.45,79.59,69,159.14,37.33,86,74.65,172.08C522.38,292.29,522.7,293.08,523.14,294.16Z"
            transform="translate(-177.14 42.3)"
          />
          <path
            fill="#f8bec4"
            d="M890.73,117.56l.06-.66.49.45Z"
            transform="translate(-177.14 42.3)"
          />
        </svg>
    );
  }
}
